import { Component } from '@angular/core';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { Language } from 'src/app/assabil-kernel/models/entities/control-tables/language-entity';
import { LanguageRequest } from 'src/app/assabil-kernel/models/dtos/control-tables/language-request';


@Component({
  selector: 'app-language-list',
  templateUrl: './language-list.component.html',
  styleUrls: ['./language-list.component.scss']
})

export class LanguageListComponent extends BasePage2<Language> {

  // Filter fields
  // ---------------------------------------------------
  code: string;
  name: string;
  // ---------------------------------------------------
      
  // ---------------------------------------------------
  languages: Language[] = [];
  // ---------------------------------------------------
  
  // ---------------------------------------------------

  constructor(
      protected toastr            : ToastrService,
      protected controlService        : ControlTablesService,
      protected router            : Router,
      protected baseService       : BaseService,
      protected leanUtilsService  : LeanUtilsService,
      protected location          : Location) {
      super(toastr, router, baseService, leanUtilsService, location);

      this.entityName = "language";
  }
  // ---------------------------------------------------
 


// ---------------------------------------------------
listFields = [
    { prop: 'languageCode', name: 'Code',  insertOnly : true},
    { prop: 'name',         name: 'Name' }
]
// ---------------------------------------------------


  getRows(): Language[] {
      return this.languages;
  }
  // ---------------------------------------------------
  
//----------------------------------------------------------------------
new(){
  let entity : Language = new Language();
  entity.inserted = true;
  entity.edit = true;
  this.languages.push(entity);
  this.languages = [...this.languages];
  }
//----------------------------------------------------------------------


//----------------------------------------------------------------------
saveRow(language: Language): Promise<Language> {
    let request  : LanguageRequest = new LanguageRequest(this.controlService.getUserInfo());
    request.languageE = language;
      return this.controlService.save(this.entityName, request);
}
//----------------------------------------------------------------------


//----------------------------------------------------------------------
loadData() {
  let request  : BaseRequest = new BaseRequest(this.controlService.getUserInfo());
  request.strArg1 = this.code;
  request.strArg2 = this.name;

  this.controlService.getList(this.entityName, request).then(result => {
      this.languages = result;
  }).catch(error => {
      this.showError(error);
  })
}
//----------------------------------------------------------------------

}



